/**
 * @param LoginForm Base widget for extending
 * @returns Checkout Login Form widget
 */
function CheckoutLoginFormClassCreator(LoginForm: import('widgets/forms/ajax/LoginForm').TLoginForm) {
    /**
     * @category widgets
     * @subcategory forms
     * @class CheckoutLoginForm
     * @augments LoginForm
     * @classdesc Checkout login form component with the next features:
     * 1. Upon successful login, replaces the current state in the history object with the cart page.<br>
     * *The aim - user who is logged in should not go back to the login page by clicking the Back button.*
     * @property {string} data-widget - Widget name `checkoutLoginForm`
     * @property {string} data-cart-url - Shopping cart URL
     * @example <caption>Example of checkout login form</caption>
     * <form
     *     action="${pdict.actionUrl}"
     *     class="b-form m-login"
     *     method="POST"
     *     name="login-form"
     *     data-widget="checkoutLoginForm}"
     *     data-event-submit.prevent="handleSubmit"
     *     data-cart-url="${URLUtils.https('Cart-Show')}"
     *     novalidate
     * >
     *     ... form content
     *
     *     <div class="b-reset_password">
     *         ... reset password modal content
     *     </div>
     * </form>
     */
    class CheckoutLoginForm extends LoginForm {
        prefs() {
            return {
                cartUrl: '',
                ...super.prefs()
            };
        }

        edit() {
            this.ref('errorMessageLabel').hide();

            this.emit('edit');
        }

        /**
         * @description Replace the current state in the history object with the cart page if submission was success
         * @param data Server JSON response once form submitted
         */
        onSubmitted(data: TServerResponse & { showPasswordResetModalForMigratedCustomer: boolean }) {
            if (data.success) {
                window.history.replaceState(null, '', this.prefs().cartUrl);
            }

            super.onSubmitted(data);
        }
    }

    return CheckoutLoginForm;
}

export type TCheckoutLoginForm = ReturnType<typeof CheckoutLoginFormClassCreator>;

export type TCheckoutLoginFormInstance = InstanceType<TCheckoutLoginForm>;

export default CheckoutLoginFormClassCreator;
